import CardComponent from "./CardComponent";

export class Quote extends CardComponent {

}
